var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBinIcon = function SvgBinIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54941 25.0002C4.8749 25.0002 5.94941 23.9257 5.94941 22.6002C5.94941 21.2747 4.8749 20.2002 3.54941 20.2002C2.22393 20.2002 1.14941 21.2747 1.14941 22.6002C1.14941 23.9257 2.22393 25.0002 3.54941 25.0002Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80929 23.3998L13.949 24.9998L18.749 5.7998H2.74902V20.3363",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.549 1H4.34902C3.92468 1 3.51771 1.16857 3.21765 1.46863C2.91759 1.76869 2.74902 2.17565 2.74902 2.6V5.8H20.349C20.349 4.52696 19.8433 3.30606 18.9431 2.40589C18.043 1.50571 16.8221 1 15.549 1V1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBinIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyMiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTMuNTQ5NDEgMjUuMDAwMkM0Ljg3NDkgMjUuMDAwMiA1Ljk0OTQxIDIzLjkyNTcgNS45NDk0MSAyMi42MDAyQzUuOTQ5NDEgMjEuMjc0NyA0Ljg3NDkgMjAuMjAwMiAzLjU0OTQxIDIwLjIwMDJDMi4yMjM5MyAyMC4yMDAyIDEuMTQ5NDEgMjEuMjc0NyAxLjE0OTQxIDIyLjYwMDJDMS4xNDk0MSAyMy45MjU3IDIuMjIzOTMgMjUuMDAwMiAzLjU0OTQxIDI1LjAwMDJaIgogICAgICAgIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aCBkPSJNNS44MDkyOSAyMy4zOTk4TDEzLjk0OSAyNC45OTk4TDE4Ljc0OSA1Ljc5OThIMi43NDkwMlYyMC4zMzYzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0xNS41NDkgMUg0LjM0OTAyQzMuOTI0NjggMSAzLjUxNzcxIDEuMTY4NTcgMy4yMTc2NSAxLjQ2ODYzQzIuOTE3NTkgMS43Njg2OSAyLjc0OTAyIDIuMTc1NjUgMi43NDkwMiAyLjZWNS44SDIwLjM0OUMyMC4zNDkgNC41MjY5NiAxOS44NDMzIDMuMzA2MDYgMTguOTQzMSAyLjQwNTg5QzE4LjA0MyAxLjUwNTcxIDE2LjgyMjEgMSAxNS41NDkgMVYxWiIKICAgICAgICBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";